import { useLocalization } from '@/hooks/useLocalization';
import { useLead } from '@/hooks/useLead';
import { useChat } from '@/hooks/useChat';
import BotMessage from '@/components/ChatMessage/BotMessage';
import OptionButton from '@/components/OptionButton/OptionButton';
import formStyles from '@/styles/forms.module.scss';

const MailIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
  </svg>
);

export default function EmailConfirmScreen() {
  const { t } = useLocalization();
  const { leadData } = useLead();
  const { confirmEmailCorrect, editEmail } = useChat();

  return (
    <BotMessage text={t('emailConfirm.message')}>
      <div className={formStyles.emailConfirm}>
        <div className={formStyles.emailChip}>
          <span className={formStyles.emailChipIcon}>
            <MailIcon />
          </span>
          <div className={formStyles.emailChipBody}>
            <span className={formStyles.emailChipLabel}>{t('emailConfirm.emailLabel')}</span>
            <span className={formStyles.emailChipValue}>{leadData.email}</span>
          </div>
        </div>

        <p className={formStyles.emailConfirmHint}>{t('emailConfirm.hint')}</p>

        <div className={formStyles.emailConfirmActions}>
          <OptionButton variant="primary" onClick={confirmEmailCorrect}>
            {t('emailConfirm.yes')}
          </OptionButton>
          <OptionButton onClick={editEmail}>
            {t('emailConfirm.no')}
          </OptionButton>
        </div>
      </div>
    </BotMessage>
  );
}
